/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {TemplateActionModalComponent} from './template-action-modal/template-action-modal.component';
import {AiGenerateModalComponent} from './template-editor/ai-generate-modal/ai-generate-modal.component';
import {FieldReviewListComponent} from './template-editor/field-review/field-review-list.component';
import {PlaceholdersTabComponent} from './template-editor/field-review/placeholders-tab.component';
import {GpDocumentEditorComponent} from './template-editor/gp-document-editor.component';
import {
  TemplateConditionsModalComponent
} from './template-editor/template-conditions-modal/template-conditions-modal.component';
import {
  TemplateSignaturePanelComponent
} from './template-editor/template-signature-panel/template-signature-panel.component';
import {TemplateManagementComponent} from './template-management.component';
import {TemplateManagementGuard} from './template-management.guard';
import {TemplateManagementService} from './template-management.service';

import {ButtonModule, CheckBoxModule} from '@syncfusion/ej2-angular-buttons';
import {DocumentEditorAllModule, DocumentEditorContainerAllModule} from '@syncfusion/ej2-angular-documenteditor';
import {
  ComboBoxModule,
  DropDownListAllModule,
  DropDownListModule,
  MultiSelectAllModule
} from '@syncfusion/ej2-angular-dropdowns';
import {
  ColorPickerModule,
  MaskedTextBoxModule,
  NumericTextBoxModule,
  SliderModule
} from '@syncfusion/ej2-angular-inputs';
import {TabModule, ToolbarModule, TreeViewModule} from '@syncfusion/ej2-angular-navigations';
import {DialogModule, TooltipModule} from '@syncfusion/ej2-angular-popups';
import {DropDownButtonModule, SplitButtonModule} from '@syncfusion/ej2-angular-splitbuttons';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {ReportsService} from '../+reports/reports.service';
import {AdministrationService} from '../+settings/administration/administration.service';
import {RouteGuard} from '../shared/authentication/roles/route-guard';
import {ChangeTrackingModule} from '../shared/change-tracking/change-tracking.module';
import {DocumentsService} from '../shared/documents/documents.service';
import {SignatureMethodModule} from '../shared/documents/signature/signature-method.module';
import {EmployeesSharedModule} from '../shared/employees/employees-shared.module';
import {ModalModule} from '../shared/modal/modal.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {CanDeactivateGuard} from '../shared/routing/can-deactivate-guard';
import {TreeDiagramModule} from '../shared/tree-diagram/tree-diagram.module';
import {DropdownTreeviewModule} from '../shared/ui/tree-multi-select/dropdown-treeview.module';
import {UiModule} from '../shared/ui/ui.module';
import {UserModule} from '../shared/user/user.module';

const routes: Routes = [
  {
    path: 'templates',
    children: [{
      path: ':id',
      component: GpDocumentEditorComponent,
      canDeactivate: [CanDeactivateGuard],
      canActivate: [TemplateManagementGuard, RouteGuard]
    },
      {
        path: '',
        component: TemplateManagementComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [TemplateManagementGuard, RouteGuard]
      }]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UiModule,
    ReactiveFormsModule,
    UserModule,
    TranslateModule,
    DropdownTreeviewModule,
    PipesModule,
    ModalModule,
    ChangeTrackingModule,
    EmployeesSharedModule,
    TreeDiagramModule,
    ToolbarModule,
    DropDownListAllModule,
    ColorPickerModule,
    SplitButtonModule,
    ComboBoxModule,
    TabModule,
    DocumentEditorAllModule,
    DocumentEditorContainerAllModule,
    DropDownListModule,
    SliderModule,
    TooltipModule,
    NumericTextBoxModule,
    CheckBoxModule,
    ButtonModule,
    DropDownButtonModule,
    DialogModule,
    MultiSelectAllModule,
    TreeViewModule,
    RouterModule.forChild(routes),
    MaskedTextBoxModule,
    SignatureMethodModule
  ],
  declarations: [
    TemplateManagementComponent,
    TemplateActionModalComponent,
    TemplateConditionsModalComponent,
    TemplateSignaturePanelComponent,
    FieldReviewListComponent,
    PlaceholdersTabComponent,
    AiGenerateModalComponent,
    GpDocumentEditorComponent
  ],
  exports: [
    RouterModule,
    GpDocumentEditorComponent
  ],
  providers: [ToastrService, AdministrationService, BsModalRef, BsModalService, TemplateManagementService, ReportsService, DocumentsService]
})
export class TemplateManagementModule {
}
